import*as t from"react";var r=t.createContext(void 0);function e(e){const o=t.useContext(r);return e||o||"ltr"}export{e as useDirection};
//# sourceMappingURL=index.js.map
